@if (time || (progressShow && progress !== undefined) || itemCountLabel) {
  <div
    class="align-items-center d-flex justify-content-end progress-container"
    data-cy="progress-bar"
    >
    <div class="align-items-center d-flex time" [class.invisible]="!time">
      <lib-icon class="mr-1" icon="clock"></lib-icon>
      <span class="mr-1" data-cy="progress-bar-time">{{time | minutesToTime : 'short' }}</span>
      @if (chaptersLeft !== false) {
        <span data-cy="progress-bar-left-count">
          ({{'PROGRESS.chapter_left_count' | translate : { count: chaptersLeft} }})
        </span>
      }
    </div>
    @if (progressShow && progress !== undefined) {
      <div  class="align-items-center d-flex justify-content-end bar">
        @if (progressIndicator === 'bar') {
          <mat-progress-bar
            class="w-100"
            [ngClass]="progressColor + '-progress-bar'"
            mode="determinate"
            [value]="progress"
            aria-label="Progress">
          </mat-progress-bar>
        }
        @if (progressIndicator === 'spinner') {
          <div class="spinner-wrapper">
            <mat-progress-spinner
              diameter="22"
              class="spinner-foreground"
              [ngClass]="progressColor + '-progress-spinner'"
              mode="determinate"
              [strokeWidth]="4"
              [value]="progress">
            </mat-progress-spinner>
            <mat-progress-spinner
              diameter="22"
              class="spinner-background"
              mode="determinate"
              [strokeWidth]="4"
              [value]="100">
            </mat-progress-spinner>
          </div>
        }
        <span>{{progress}}%</span>
      </div>
    }
    @if (itemCountLabel) {
      <span class="item-count">
        {{itemCountLabel}}
      </span>
    }
  </div>
}
